import { defineMessages } from 'react-intl';

export default defineMessages({
  contraAccount: {
    id: 'sentinel.components.transferPanel.contraAccount',
    defaultMessage: 'Contra Account',
  },
  journalType: {
    id: 'sentinel.components.transferPanel.journalType',
    defaultMessage: 'Journal Type',
  },
  program: {
    id: 'sentinel.components.transferPanel.program',
    defaultMessage: 'Program',
  },
});



// WEBPACK FOOTER //
// ./src/components/TransferPanelJournalDetails/messages.js